import columnNames from './columns';

const getColumnLabelsForLanguage = (lang = 'en') => {
  const result = columnNames[lang];
  return result || columnNames.en;
};

export default getColumnLabelsForLanguage;
